<ngx-spinner bdColor="rgba(0, 0, 0, 0.8)" size="medium" color="#fff" type="ball-grid-beat" [fullScreen]="true">
    <p style="color: white">Please Wait...</p>
</ngx-spinner>

<div class="header_second">
    <div class="Dashboard_head">Transactions

        <button mat-stroked-button class="me-2" color="primary" (click)="back()"><mat-icon>arrow_back</mat-icon>
            Back</button>
    </div>
</div>

<!-- <div class="row d-flex justify-content-between align-items-center" style="margin: 0.5rem;">
    <div class="whatsapp-card col-xl-3 col-lg-3 col-md-3 col-sm-3 col-6">
        <p class="m-0">WhatsApp ID Card </p>
        <span class="text-success"> Sent : {{yesCount}} </span>&nbsp;
        <span class="text-danger"> Pending : {{noCount}} </span>
    </div>
    <div style="text-align: end;" class="col-xl-6 col-lg-9 col-md-9 col-sm-9 col-6 p-0">
        <button class="me-2" [matMenuTriggerFor]="create_image" style="color: green;" mat-stroked-button>Create
            Images</button>
        <mat-menu #create_image="matMenu">
            <button mat-menu-item class="me-2" (click)="Create_Remaining_Card()">Create Remaining</button>
            <button mat-menu-item class="me-2" (click)="Create_All_Card()">Create All</button>
        </mat-menu>

        <button class="me-2" [matMenuTriggerFor]="menu" style="color: rgb(255, 0, 0);" mat-stroked-button>Send ID
            Card</button>
        <mat-menu #menu="matMenu">
            <button mat-menu-item class="me-2" (click)="Send_Pending_Card()">Send Pending</button>
            <button mat-menu-item class="me-2" (click)="Send_All()">Send All</button>
        </mat-menu>
        <button mat-stroked-button color="primary" (click)="Reports()">Report</button>
    </div>
</div> -->

<div class="mat-elevation-z8" style="margin: 0.5rem;">
    <div class="d-flex justify-content-between align-items-center">
        <mat-form-field appearance="outline" subscriptSizing="dynamic">
            <mat-label>Search</mat-label>
            <input matInput (keyup)="applyFilter($event)" placeholder="Search" #input>
        </mat-form-field>

    </div>
    <div class="table-responsive">
        <table mat-table [dataSource]="dataSource" matSort recycleRows>

            <!-- Position Column -->
            <ng-container matColumnDef="id" sticky>
                <th mat-header-cell *matHeaderCellDef mat-sort-header> No. </th>
                <td mat-cell *matCellDef="let element">
                    <div style="display: flex; align-items: center; gap: 6px;">
                        {{element.id}}
                    </div>
                </td>
            </ng-container>
            <ng-container matColumnDef="mem_id" sticky>
                <th mat-header-cell *matHeaderCellDef mat-sort-header> Mem ID </th>
                <td mat-cell *matCellDef="let element">
                    <div style="display: flex; align-items: center; gap: 6px;">
                        {{element.mem_id}}
                    </div>
                </td>
            </ng-container>

            <!-- Name Column -->
            <ng-container matColumnDef="name">
                <th mat-header-cell *matHeaderCellDef mat-sort-header> Name </th>
                <td mat-cell *matCellDef="let element"> {{element.name}} </td>
            </ng-container>

            <ng-container matColumnDef="amount">
                <th mat-header-cell *matHeaderCellDef mat-sort-header> Amount </th>
                <td mat-cell *matCellDef="let element"> {{element.amount | currency:'INR'}} </td>
            </ng-container>

            <ng-container matColumnDef="order_id">
                <th mat-header-cell *matHeaderCellDef mat-sort-header> Order ID </th>
                <td mat-cell *matCellDef="let element"> {{element.order_id}} </td>
            </ng-container>

            <ng-container matColumnDef="mobile">
                <th mat-header-cell *matHeaderCellDef mat-sort-header> mobile </th>
                <td mat-cell *matCellDef="let element"> {{element.mobile}} </td>
            </ng-container>

            <ng-container matColumnDef="transaction_id">
                <th mat-header-cell *matHeaderCellDef mat-sort-header> Transaction ID </th>
                <td mat-cell *matCellDef="let element"> {{element.transaction_id}} </td>
            </ng-container>

            <ng-container matColumnDef="status">
                <th mat-header-cell *matHeaderCellDef mat-sort-header> Status </th>
                <td mat-cell *matCellDef="let element">
                    <span class="payment-chip" [ngClass]="getPaymentClass(element.status)">
                        {{ element.status | titlecase }}
                    </span>
                </td>
            </ng-container>

            <ng-container matColumnDef="mode">
                <th mat-header-cell *matHeaderCellDef mat-sort-header>Payment Mode </th>
                <td mat-cell *matCellDef="let element"> {{element.mode | titlecase}} </td>
            </ng-container>

            <ng-container matColumnDef="date">
                <th mat-header-cell *matHeaderCellDef mat-sort-header> date </th>
                <td mat-cell *matCellDef="let element"> {{element.date | date:'dd/MM/yyyy'}} </td>
            </ng-container>

            <ng-container matColumnDef="coupon_code">
                <th mat-header-cell *matHeaderCellDef mat-sort-header> Coupon Used</th>
                <td mat-cell *matCellDef="let element"> {{element.coupon_code}} </td>
            </ng-container>


            <tr mat-header-row *matHeaderRowDef=" displayedColumns;sticky: true"></tr>
            <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
        </table>
    </div>

    <mat-paginator [pageSizeOptions]="[100, 250, 500]" showFirstLastButtons
        aria-label="Select page of periodic elements">
    </mat-paginator>
</div>